<template>
    <div>
        <div class="selected-thumbnail-display">
            <div style="height:calc(100% - 37px);position:relative" :style="isAudioFile ? 'bottom:3px;':''">
            <template v-if="isVideoFile">
                <div>
                    <video-player v-if="isPlayerCanBeLoaded"  :frameRate="frameRate" :isCurrentTimeUpdateRequired="true" :isProgressbarRequired="true" ref="videoPlayerEl" id="video-player-id" @metaDataLoaded="playerFullyLoaded('videoPlayerEl','video')" @controller="setController" :options="videoOptions" style="height:100%;width:100%"/>
                </div>
            </template>
            <customAudioPlayer :key="audioPlayerFileInfo && audioPlayerFileInfo._id" @audioDuration="handleAudioLoaded" @stopPlaying="isPlaying = false" @playerPaused="isPlaying = false" @audioStartedPlaying="isPlaying = true" ref="audioPlayerRef"  :isPlayButtonRequired="false" v-if="isAudioFile" :fileInfo="audioPlayerFileInfo" :subclipDetails="getAudioSubclipDetails" style="bottom: 19px;border-radius:0px !important;" class="audio-player" :isBorderRequired="false"></customAudioPlayer>
         <!--     <audio v-if="isAudioFile" id="audio-player-id" ref="audioPlayerRefEl" class="audio-player" @loadedmetadata="playerFullyLoaded('audioPlayerRefEl','audio')" controls="controls" controlslist="nodownload">
                <source :src="audioUrl" type="audio/mpeg" />
            </audio> -->
            <!-- <embed v-if="!isVideoFile" src="http://www.pdf995.com/samples/pdf.pdf" alt="pdf" style="height:100%;width:100%" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"> -->
            <img v-if="isImageFile || isAudioFile" :style="isAudioFile ? 'padding:46px;':''"  :src="getThumbnailPath(basicAssetInfo)" @error="replaceByDefaultImage" style="max-width:100%;max-height:100%;object-fit:contain">
            </div>
            <div  :style="(isVideoFile || isAudioFile) ? 'display: flex; justify-content: space-between;align-items: center;height:37px !important;': 'display: flex; justify-content: end; align-items: center;height: 37px;'" style="background:#1f232a">
                <div id="main_window_palyer_icons_wrapper" v-if="isVideoFile || isAudioFile">
                  <ul>
                      <li title="Toggle Play-Pause (spacebar)"><button style="display: flex; align-items: center;justify-content:center;" class="btn btn-outline-secondary play common-markinmarkout-action-btn" @click="playPauseToggle()">  <span v-show="isPlaying" class="common-play-pause"><svg style="width:18px;height:18px;margin-top:1px !important" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg></span><span v-show="!isPlaying" class="common-play-pause"><svg  style="width:18px;height:18px;;margin-top:1px !important" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"/></svg><span style="visibility:hidden;"></span></span> </button></li>
                      <li title="Backward 1 Second (9)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoBy1Sec('backward')">-1S</button></li>
                      <li title="Forward 1 Second (0)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoBy1Sec('forward')">+1S</button></li>
                      <li v-if="!isAudioFile" title="Backward 1 Frame (-)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoByFrame('backward')">-1F</button></li>
                      <li v-if="!isAudioFile" title="Forward 1 Frame (=)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoByFrame('forward')">+1F</button></li>
                      <li title="Fast Forward" style="margin-inline-end:6px;"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="updateFastwardValue('forward')" style="width:50px;">FF</button></li>
                      <li v-if="currentVideoSpeed != 1" style="display: flex;align-items: center;color: #bcbcbc;margin-inline-start: 3px;">
                          <span style="border: 1px solid rgb(74, 74, 74) !important; border-radius: 15px !important; width: 32px; padding: 4px; text-align: center; background: rgb(40, 45, 49) !important; height: 20px; justify-content: center; display: flex; align-items: center; font-size: 13px;">{{currentVideoSpeed}}x</span>
                      </li>
                  </ul>
                  <div class="comm-forward-icon" v-if="currentVideoSpeed != 1" style="height:100%;" @click="resetVideoSpped">
                      <button class="btn btn-outline-secondary common-markinmarkout-action-btn" style="padding: 5px 23px;">Reset</button>
                  </div>
                </div>
                <template>
                    <svg width="2em" height="1.5em"  :style="(isVideoFile || isAudioFile) ? 'margin-top:0 !important;': ''"   v-on:click="closeAssetDetails(getThumbnailPath(basicAssetInfo))" viewBox="0 0 16 16" class="bi bi-box-arrow-down-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8.636 12.5a.5.5 0 0 1-.5.5H1.5A1.5 1.5 0 0 1 0 11.5v-10A1.5 1.5 0 0 1 1.5 0h10A1.5 1.5 0 0 1 13 1.5v6.636a.5.5 0 0 1-1 0V1.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6.636a.3c3c3c5.5 0 0 1 .5.5z"/>
                        <path fill-rule="evenodd" d="M16 15.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h3.793L6.146 6.854a.5.5 0 1 1 .708-.708L15 14.293V10.5a.5.5 0 0 1 1 0v5z"/>
                    </svg>
                </template>
                <!-- <template v-if="isFullscreenPreviewAllowed">
                    <svg width="2em" height="1.5em" v-on:click="closeAssetDetails(getThumbnailPath(basicAssetInfo))" viewBox="0 0 16 16" class="bi bi-box-arrow-up-left" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M7.364 3.5a.5.5 0 0 1 .5-.5H14.5A1.5 1.5 0 0 1 16 4.5v10a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 3 14.5V7.864a.5.5 0 1 1 1 0V14.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5H7.864a.5.5 0 0 1-.5-.5z"/>
                        <path fill-rule="evenodd" d="M0 .5A.5.5 0 0 1 .5 0h5a.5.5 0 0 1 0 1H1.707l8.147 8.146a.5.5 0 0 1-.708.708L1 1.707V5.5a.5.5 0 0 1-1 0v-5z"/>
                    </svg>
                </template> -->
            </div>
        </div>
        <div style="overflow:auto" class="heightSet">
            <ul>
                <li>
                    <div class="key-style">{{$t('Filename')}}</div>
                    <div class="value-style" style="overflow-wrap:anywhere">{{getFileName(basicAssetInfo)}}</div>
                </li>
                <li v-if="barcodeInfoFromStartup.enable_reference_id_workflow && Object.keys(basicAssetInfo).includes('reference_id') &&
                !['undefined',null].includes(basicAssetInfo.reference_id) &&  basicAssetInfo.reference_id.length > 0">
                  <div class="key-style">{{barcodeInfoFromStartup.alias &&  barcodeInfoFromStartup.alias.alias_name?barcodeInfoFromStartup.alias.alias_name:"Reference ID"}}</div>
                  <div class="value-style">{{basicAssetInfo.reference_id}}</div>
              </li>

              <li v-if="barcodeInfoFromStartup.enable_department && Object.keys(basicAssetInfo).includes('department_info') &&
                      !['undefined',null].includes(basicAssetInfo.department_info) &&  basicAssetInfo.department_info.name">
                        <div class="key-style">{{barcodeInfoFromStartup.department_alias &&  barcodeInfoFromStartup.department_alias.alias_name?barcodeInfoFromStartup.department_alias.alias_name:"Department"}}</div>
                        <div class="value-style">{{basicAssetInfo.department_info.name}}</div>
                    </li>
                <li>
                    <div class="key-style">{{$t('Path')}}</div>
                    <div class="value-style" style="overflow-wrap:anywhere">{{getFilePath(basicAssetInfo)}}</div>
                </li>
                <li v-if="basicAssetInfo.storage_class && basicAssetInfo.storage_class.length">
                    <div class="key-style">{{$t('Location')}}</div>
                    <div class="value-style">
                        <div v-for="storageClass in basicAssetInfo.storage_class" class="d-inline-flex" :key="storageClass">
                            <svg v-if='storageClass == "Disk"' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(basicAssetInfo.location_info,storageClass)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                              </svg>
                              <span style="margin-inline-start:4px">{{ storageClass }}</span>
                        </div>
                        </div>
                </li>
                <li>
                    <div class="key-style">{{$t('Date Added')}}</div>
                    <div class="value-style">{{getDateAndTimeInConfiguredFormat(basicAssetInfo.added_datetime)}}</div>
                </li>
                <li>
                    <div class="key-style">{{$t('Date Created')}}</div>
                    <div class="value-style">{{getDateAndTimeInConfiguredFormat(basicAssetInfo.created_datetime)}}</div>
                </li>
                <li>
                    <div class="key-style">Size</div>
                    <div class="value-style">{{humaniseSize(basicAssetInfo)}}</div>
                </li>
                <li v-if="'mime_type' in basicAssetInfo && basicAssetInfo.mime_type && basicAssetInfo.mime_type.startsWith('video') &&
                 'duration' in basicAssetInfo && basicAssetInfo.duration">
                    <div class="key-style">{{$t('Duration')}}</div>
                    <div class="value-style">{{getHumanReadableDuration(basicAssetInfo.duration)}}</div>
                </li>
                <li>
                    <div class="key-style">User name</div>
                    <div class="value-style">{{getDisplayDataOfUserUsingId(basicAssetInfo.user_id).username }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
// import myVideo from 'vue-video';
import VideoPlayer from "../core/VideoPlayer.vue";
import Utils from "../../components.utils.js" ;
import {NotifierConstants} from "../../components.constants.js" ;
import {mapMutations, mapActions,mapGetters} from "vuex"
import Constants from "../../components.constants.js";
import subclipPreviewMixin from '../../mixins/SubclipPreviewMixin.js';
import customAudioPlayer from '../customAudioPlayer/AudioPlayerComponent.vue';
import cloneDeep from 'lodash.clonedeep';

export default {
    props:["basicAssetInfo","subclipDetails",'transcriptPlayObject','autoPlay'],
    mixins:[subclipPreviewMixin],
    watch:{
        basicAssetInfo(newVal, oldVal){// eslint-disable-line no-unused-vars

        if ((newVal.category_id)&&(!("path" in newVal))){
          if (newVal.category_id != oldVal.category_id){
            this.updateRoute(newVal.category_id)
          }
        }else{
          this.route = ""
        }


      if(newVal._id != oldVal._id){

          if((newVal && newVal.asset_type && newVal.asset_type == 'subclip'  && (!newVal.subclip_type ||["soft","smart","image_captioned"].includes(newVal.subclip_type)))){
                this.initializeSubclipPreview(newVal);
                return;
            }else{
                try{
                    this.removeTimeLineMarkers();
                }catch(e){console.log(e)}
            }

            try{
                if(this.videoFrameCallbackID) {
                    console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                    this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
                }
            }catch(e){console.log(e)}
        }

        if(Object.prototype.hasOwnProperty.call(newVal,'mime_type') && newVal.mime_type.startsWith("video")){
                if (this.getLowresPath(newVal) != this.getLowresPath(oldVal)){
                    this.videoOptions.sources = [{
                        src:this.getLowresPath(newVal),
                        type: "video/mp4"
                    }]
                    // if (  this.controller.player){
                    //     this.controller.restartPlayer(this.videoOptions.sources[0])
                    // }
                    this.controller.player.src(this.videoOptions.sources);
                    this.controller.player.load();
                }
            }else if(Object.prototype.hasOwnProperty.call(newVal,'mime_type') && newVal.mime_type.startsWith("audio")){
                if (this.getAudiowaveform(newVal) != this.getAudiowaveform(oldVal)){
                    this.audioPlayerFileInfo = this.basicAssetInfo;
                    this.audioUrl = this.getAudiowaveform(newVal)
                    document.getElementById("audio-player-id").load(); 
                }
            }
        },

       subclipDetails(newVal, oldVal){
            if(newVal && Object.keys(newVal).length){
                if(newVal._id != oldVal._id){
                    if(this.subclipDetails && Object.keys(this.subclipDetails).length && this.subclipDetails.asset_type && this.subclipDetails.asset_type == 'subclip' && (!this.subclipDetails.subclip_type || ["soft","smart","image_captioned"].includes(this.subclipDetails.subclip_type))){
                        if(this.isAudioFile){
                            this.$refs.audioPlayerRef.playSubclipArea(newVal);
                            return;
                        }
                        this.addSubclipMarkers(newVal);
                    }
                }
            }
        },

        transcriptPlayObject(newVal, oldVal){
            console.log(`[transcriptPlayObject transcriptPlayObject]`,newVal, oldVal);
           if(newVal && Object.keys(newVal).length){
            if(this.isVideoFile && this.autoPlay){
                    try{
                        this.removeTimeLineMarkers();
                    }catch(e){console.log(e)}
                    this.controller.player.currentTime(newVal.media_in/1000);
                    this.controller.player.play();
                }else if(this.isAudioFile){
                    // this.$refs.audioPlayerRefEl.currentTime = (newVal.media_in/1000);
                    // this.$refs.audioPlayerRefEl.play();
                    this.$refs.audioPlayerRef.setCurrentTime(newVal.media_in/1000);
                    this.$refs.audioPlayerRef.playVideo();
                }
           }
        }
    },
    computed:{
      ...mapGetters("users",["getUsersBasicInfoFromStore"]),
      ...mapGetters("registry",["getDontPlayOverlayScreenOverMiniplayerAssetDoc"]),
        barcodeInfoFromStartup:{
            get(){
                return this.$store.state.startUpData.startUpDataDetails;
            }
        },
        isAudioFile(){
            let v = false;
            try {
                if(this.basicAssetInfo && Object.prototype.hasOwnProperty.call(this.basicAssetInfo,'mime_type') && this.basicAssetInfo.mime_type.startsWith("audio")){
                     v = true;
                }   
            } catch (err) {
                console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
            }
            try {
                if(this.basicAssetInfo && Object.prototype.hasOwnProperty.call(this.basicAssetInfo,'markers') 
                   && Object.prototype.hasOwnProperty.call(this.basicAssetInfo.markers,'mime_type')){
                    v = this.basicAssetInfo.markers.mime_type == 'audio';
                }   
                
            } catch (err) {
                console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
            }
            return v;
        },
        isVideoFile(){
            let v = false;
            try {
                if(this.basicAssetInfo && this.basicAssetInfo.asset_type && this.basicAssetInfo.asset_type == 'subclip' && this.isAudioFile == false && (!this.basicAssetInfo.subclip_type || ["soft","smart","image_captioned"].includes(this.basicAssetInfo.subclip_type))) {
                    //return true;
                    v = true;
                }   
            } catch (err) {
                console.error(`[isVideoFile][files][Error while checking filetype-${err}]`)
            }
            try {
                if(this.basicAssetInfo && Object.prototype.hasOwnProperty.call(this.basicAssetInfo,'mime_type') && this.basicAssetInfo.mime_type.startsWith("video")){
                    v = true;
                }   
            } catch (err) {
                console.error(`[isVideoFile][files][Error while checking filetype-${err}]`)
            }
            return v;
        },
        isImageFile(){
          let v = false; 
           try {
                if(
                    (this.basicAssetInfo && Object.prototype.hasOwnProperty.call(this.basicAssetInfo, 'mime_type') && this.basicAssetInfo.mime_type &&
                        (this.basicAssetInfo.mime_type.startsWith("image") || this.basicAssetInfo.mime_type.startsWith("audio") || this.basicAssetInfo.mime_type.startsWith("doc")))
                    ||
                    (Object.keys(this.subclipDetails).length && Object.prototype.hasOwnProperty.call(this.subclipDetails, 'markers') && Object.prototype.hasOwnProperty.call(this.subclipDetails.markers, 'mime_type') && this.subclipDetails.markers.mime_type === 'audio')
                ){
                    v = true;
                }
            } catch (err) {
                console.error(`[isImageFile][files][Error while checking filetype-${err}]`);
            }
            return v;
        },
        isFullscreenPreviewAllowed(){
            let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
            return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.basicAssetInfo)) > -1
        },

        getAudioSubclipDetails(){
            if(this.audioSubclipDetails && Object.keys(this.audioSubclipDetails).length){
                return this.audioSubclipDetails;
            }
            return this.subclipDetails;
        },
    },
    methods:{
        handleAssetDocKeyBoardShortcuts(event){
            let keyCode = event.keyCode || event.which;
            let pressedElement = String(event.target.nodeName).toLowerCase();
            if(pressedElement == 'input' || pressedElement == 'textarea' || pressedElement == 'select' ) return true;
            let videoAudioRef = null;
            if(this.isVideoFile){
                videoAudioRef = this.$refs.videoPlayerEl.$el.querySelector('video');
            }

            if(this.isAudioFile){
                videoAudioRef = this.$refs.audioPlayerRef.$el.querySelector('audio');
            }
             
            if(keyCode === 32){ //spacebar
               event.preventDefault(); // don't allow to scroll
               try{
                    if(this.$route && this.getDontPlayOverlayScreenOverMiniplayerAssetDoc.includes(this.$route.name)){
                         return; // don't play when tag-metadata window is opened on top , it will avoid 2 times playing
                    }
                }catch(e){console.log(e)}

                if(videoAudioRef && videoAudioRef.paused){
                    this.isPlaying = true;
                    videoAudioRef.play()
                }else{
                    this.isPlaying = false;
                    videoAudioRef.pause();
                }
            }

        },
        handleAudioLoaded(){
            // Changed the condition from 'this.transcriptPlayObject.media_in' to "'media_in' in this.transcriptPlayObject", bcz, when medi_in value is 0 the check is failing
            if(this.transcriptPlayObject && 'media_in' in this.transcriptPlayObject){
                setTimeout(()=> {
                    this.$refs.audioPlayerComponent.setCurrentTime(this.transcriptPlayObject.media_in/1000);
                    this.$refs.audioPlayerComponent.playSubclipArea({markers:{start:this.transcriptPlayObject['media_in'], end:this.transcriptPlayObject["media_out"]}});
                })
            }

            if(this.basicAssetInfo && Object.prototype.hasOwnProperty.call(this.basicAssetInfo,'markers')){
               this.$refs.audioPlayerRef.playSubclipArea(this.basicAssetInfo.markers)
            }
        },
        getColorBasedOnExpiry(locationInfo,storage){
            return Utils.getAWSStorageIconColorBasedOnExpiry(locationInfo,storage)
        },
        getMasterAssetForSubclip(fileObj){
            return new Promise((resolve) => {
                this.getAssetInfoFromServer({params:{assetId:fileObj.master_asset_id}}).then((data) => {
                    if(data && data.asset)
                       resolve(data.asset);
                })
            });
        },
        getDisplayDataOfUserUsingId(userId){
            return Utils.getDisplayDataOfUser(userId, this.getUsersBasicInfoFromStore);
        },
       getDurationFormat(duration){
        const date = new Date(duration * 1000); // convert to milliseconds
        const hours = date.getUTCHours();
        if(hours > 0){
            return '00:00:00.00'
        }else{
            return '00:00.00'
        }
       },
        formatDurationHHMMSS_or_MMSS(duration) {
           return Utils.getExactDuationInSeconds(duration , this.frameRate, '.');
        },
        setProgressLabel(duration){
            try{
                [].forEach.call(document.querySelectorAll(`.player-current-time-division`),(el) => {
                    el.remove();
                });
            }catch(e){console.log(e)}
            let progressBar = this.$refs.videoPlayerEl.$el.querySelector('.vjs-control-bar');
            let currentProgressEl = document.createElement('div');
            currentProgressEl.classList.add('player-current-time-division');
            currentProgressEl.innerHTML = `<span class="currrent-time">${this.getDurationFormat(duration)}</span> <span class="time-division-label">/</span> <span class="full-time-of-time-division">${this.formatDurationHHMMSS_or_MMSS(duration)}</span>`;
            progressBar.insertBefore(currentProgressEl,progressBar.querySelector('.vjs-fullscreen-control.vjs-control'));
        },
        playerFullyLoaded(ref,type){
            if(this.basicAssetInfo && this.basicAssetInfo.asset_type && this.basicAssetInfo.asset_type == 'subclip' && (!this.basicAssetInfo.subclip_type || ["soft","smart","image_captioned"].includes(this.basicAssetInfo.subclip_type)))
                this.addSubclipMarkers(this.basicAssetInfo);

            if(this.subclipDetails && Object.keys(this.subclipDetails).length && this.subclipDetails.asset_type && this.subclipDetails.asset_type == 'subclip' && (!this.subclipDetails.subclip_type || ["soft","smart","image_captioned"].includes(this.subclipDetails.subclip_type))){
                this.addSubclipMarkers(this.subclipDetails);
            }
            let media = null;
            if(type == 'video'){
              media = this.$refs[ref].$el.querySelector(type);
              try{
                 this.setProgressLabel(this.controller.player.duration());
              }catch(e){console.log(e)}
                try{
                    this.activeAssetDetailsPlayer({type:'video',player:this.controller.player})
                }catch(e){console.log('e')}
            }else{
              media = this.$refs[ref];
               try{
                    this.activeAssetDetailsPlayer({type:'audio',player:media})
               }catch(e){console.log('e')}
            }
            media.playbackRate = this.currentVideoSpeed;

            if(media.paused){
                this.isPlaying = false;
            }
           
            try{
                media.removeWSEventListener("pause", this.updatePlayerPauseAction);
                media.removeWSEventListener("play",  this.updatePlayerPlayAction);
            }catch(e){console.log(e)}
            media.addEventListener("pause", this.updatePlayerPauseAction);
            media.addEventListener("play",  this.updatePlayerPlayAction);

            if(this.transcriptPlayObject && Object.keys(this.transcriptPlayObject).length){
                  if(this.isVideoFile){
                    this.controller.player.currentTime(this.transcriptPlayObject.media_in/1000);
                    this.controller.player.play();
                  }else if(this.isAudioFile){
                      this.$refs.audioPlayerRefEl.currentTime = (this.transcriptPlayObject.media_in/1000);
                      this.$refs.audioPlayerRefEl.play();
                  }
            }
        },
        handleFullScreenRequest(){
           if(document.querySelectorAll('.subclip-timeline-marker') && document.querySelectorAll('.subclip-timeline-marker').length){
                if(this.controller.player.isFullscreen()){
                    setTimeout(() => {
                        this.addLineBetweenMarkers();
                    },100);
                }else{
                    this.addLineBetweenMarkers();
                }
            }
        },
        async initializeSubclipPreview(fileObj){
           let asset = await this.getMasterAssetForSubclip(fileObj);
           this.audioSubclipDetails = null;
           if(this.isVideoFile){
                this.videoOptions.sources = [{
                    src:this.getLowresPath(asset),
                    type: "video/mp4"
                }]
                this.isPlayerCanBeLoaded = true;
                // if (this.controller.player && !this.controller.player.paused()){
                //     this.controller.restartPlayer(this.videoOptions.sources[0])
                // }
                this.controller.player.src(this.videoOptions.sources);
                this.controller.player.load();
           }

           if(this.isAudioFile){
                let masterClipAlreadyLoaded = false;
                if(this.audioPlayerFileInfo && this.audioPlayerFileInfo._id == asset._id){
                    masterClipAlreadyLoaded = true;
                }
                this.audioPlayerFileInfo = cloneDeep(asset);
                this.audioSubclipDetails = {"markers":fileObj.markers};
                this.audioUrl = this.getAudiowaveform(asset);
                if(masterClipAlreadyLoaded){
                    this.$nextTick(()=>{
                       this.$refs.audioPlayerRef.playSubclipArea({"markers":fileObj.markers});
                    });
                }
            }

        },
        addSubclipMarkers(markinMarkoutObj){
         /*    if(this.subclipDetails && Object.keys(this.subclipDetails).length){ // change to subclip from metadata dock
                markinMarkoutObj = this.subclipDetails;
            } */
            this.$refs.videoPlayerEl.$el.classList.add('sub-clip-markin-markout-play');
            let start = this.getMarkerValue(markinMarkoutObj.markers.start);
            let end = this.getMarkerValue(markinMarkoutObj.markers.end);
            this.addMarkersToTimeline([{time:start,name:'markin'},{time:end,name:'markout'}]);
            setTimeout(()=> {
                this.addLineBetweenMarkers();
            },100);
            this.controller.player.currentTime(start);
            if(this.controller.player.paused()  && this.autoPlay) this.controller.player.play();
            try{
                if(this.videoFrameCallbackID) {
                    console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                    this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
                }
            }catch(e){console.log(e)}
            this.$nextTick(()=>{
                this.currentMarkoutValue = end;
                // alert('inside');
                this.videoFrameCallbackID = this.controller.player.requestAnimationFrame(this.videoFrameCallback);
            });
            // this.controller.player.pause();
        },
        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        playSubClipPreview(markinMarkoutObj,callback){
            this.controller.player.currentTime(markinMarkoutObj.markin);
            this.controller.player.play();
            try{this.controller.player.off('timeupdate')}catch(e){console.log(e)}
            this.controller.player.on('timeupdate',() =>{ 
                if(this.controller.player.currentTime() >= markinMarkoutObj.markout){
                    this.controller.player.pause();
                   if(callback && typeof callback == 'function') callback('stopPlayer');
                   try{this.controller.player.off('timeupdate')}catch(e){console.log(e)}
                }
            });
        },
        getSvgIconForStorageClass(type){
            return this.svgIconForStorageClass[type];
        },
        getFileName(fileInfo){
            return fileInfo.file_name?fileInfo.file_name:fileInfo.slug_name
        },
        getFilePath(fileInfo){
            if ("path" in fileInfo){
                return fileInfo.path
            }else{
                return this.getCategoryRoutefromId(fileInfo.category_id)
            }
            
        },
        getCategoryRoutefromId(){
            return this.route
        },
        setController(controller){
            this.controller = controller;
            try{
               this.controller.player.off("fullscreenchange", this.handleFullScreenRequest);
            }catch(e){console.log(e)}
            this.controller.player.on("fullscreenchange", this.handleFullScreenRequest);
        },
        
        closeAssetDetails(thumbnail){
            this.$emit("hideAssetDetails",thumbnail);
        },
        humaniseSize(file){
            if(file.size){
                let data = Utils.humanizeSize(file.size);
                return `${data["value"]} ${data["unit"]}`;
            }else{
                return '-'
            }
        },
        getHumanReadableDuration(duration){
            return Utils.getDurationInSeconds(duration, true)
        },
        getThumbnailPath(file){
          return Utils.getThumbnailPathfromFileInfo(file)
        },
        getLowresPath(file){
          return Utils.getLowresPathfromFileInfo(file)
        },
        getAudiowaveform(file){
            return Utils.getAudiowaveformFromFileInfo(file)
        },
        updateRoute(categoryId){
          if(categoryId.trim().length <= 0){
            return
          }
          this.getCategoryTreefromId({ params: { categoryId:categoryId}}).then((route)=>{
            this.route = route
        })
        },
        handleFileUpdateNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
            let path = notification.message.path
            let parent_path = notification.message.parent_path
            if (this.basicAssetInfo.path == path){
                if (this.basicAssetInfo.mime_type.startsWith("video")){
                    Object.assign(this.basicAssetInfo, notification.message)

                    this.videoOptions.sources = [{
                            src:this.getLowresPath(notification.message),
                            type: "video/mp4"
                        }]
                    if (  this.controller.player){
                        this.controller.restartPlayer(this.videoOptions.sources[0])
                    }
                }else if (this.basicAssetInfo.mime_type.startsWith("audio")){
                    this.audioUrl = this.getAudiowaveform(this.basicAssetInfo)
                }else if (this.basicAssetInfo.mime_type.startsWith("image")){
                    Object.assign(this.basicAssetInfo, notification.message)
                }
                console.log(`[handleFileUpdateNotification][AssetDetails][File(${path}) updated in path->${parent_path}]`)
            }
            }
        },
        handleFileArchivedNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
            let path = notification.message.path
            if (this.basicAssetInfo.path == path && this.basicAssetInfo.storage_class != undefined){
                this.basicAssetInfo.storage_class = notification.message.storage_class;
            }
            }
        },
        registerForNotification(){
            this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification, 
                                     callback:this.handleFileUpdateNotification,
                                     parent:"AssetDetails"})
            this.addWSEventListener({eventname:NotifierConstants.fileArchivedNotification, callback:this.handleFileArchivedNotification,parent:"AssetDetails"})
        },
        unRegisterForNotification(){
            this.removeWSEventListener({eventname:NotifierConstants.fileModifiedNotification, 
                                     callback:this.handleFileUpdateNotification,
                                     parent:"AssetDetails"})
            this.removeWSEventListener({eventname:NotifierConstants.fileArchivedNotification, callback:this.handleFileArchivedNotification,parent:"AssetDetails"})
        },
         
        updateFastwardValue(speedAction){
            let video = null;
            if(this.isVideoFile){
               video = this.$refs.videoPlayerEl.$el.querySelector('video');
            }else{
               video = this.$refs.audioPlayerRef.getAudioPlayer()//this.$refs.audioPlayerRefEl;
            }
    
            if(speedAction == 'forward'){
                if(this.currentVideoSpeed == 0.5){
                    this.currentVideoSpeed = 1;
                }else if(this.currentVideoSpeed > 0.5 && this.currentVideoSpeed < 5){
                    this.currentVideoSpeed++
                }else if(this.currentVideoSpeed >= 5){
                    this.currentVideoSpeed = 0.5;
                }
            }
            video.playbackRate = Number(this.currentVideoSpeed);
        
        },
        resetVideoSpped(){
           let video = null;
            if(this.isVideoFile){
               video = this.$refs.videoPlayerEl.$el.querySelector('video');
            }else{
               video = this.$refs.audioPlayerRef.getAudioPlayer();//this.$refs.audioPlayerRefEl;
            }
            video.playbackRate = 1;
            this.currentVideoSpeed = 1;
        },
        forwardBackwardVideoByFrame(type){
            if (!type) {
                console.log("Invalid type");
                return false;
            }
            let video = null;
            if(this.isVideoFile){
               video = this.$refs.videoPlayerEl.$el.querySelector('video');
            }else{
               video = this.$refs.audioPlayerRef.getAudioPlayer();//this.$refs.audioPlayerRefEl;
            }
            if (video) {
                let dur = video.duration; //full duration of video
                let curDur = video.currentTime; //current time of a video
                if (dur != undefined && curDur != undefined) {
                    //forward 1 second
                    if (type == "forward" && curDur < (dur + 0.04)) {
                        video.currentTime = (curDur + 0.04)
                        Utils.getExactDuationInSeconds(curDur + 0.04);
                    }

                    //backward 1 second
                    if (type == "backward" && curDur > 0.04) {
                        video.currentTime =(curDur - 0.04)
                        Utils.getExactDuationInSeconds(curDur - 0.04);
                    }
                }
            }
        },

        forwardBackwardVideoBy1Sec(action) {
            if (!action) {
                console.log("Invalid action");
                return false;
            }
            let video = null;
            if(this.isVideoFile){
               video = this.$refs.videoPlayerEl.$el.querySelector('video');
            }else{
               video = this.$refs.audioPlayerRef.getAudioPlayer();//this.$refs.audioPlayerRefEl;
            }
            if (video) {
                let dur = video.duration; //full duration of video
                let curDur = video.currentTime; //current time of a video
                if (dur != undefined && curDur != undefined) {
                    //forward 1 second
                    if (action == "forward" && curDur < (dur + 1)) {
                        video.currentTime = curDur + 1
                    }
        
                    //backward 1 second
                    if (action == "backward" && curDur > 1) {
                    video.currentTime = curDur - 1
                    }
                }
            }
        
        },

        playPauseToggle(){
            if(this.isAudioFile){
                if(this.$refs.audioPlayerRef.getAudioPlayer().paused){
                    this.$refs.audioPlayerRef.getAudioPlayer().play();
                    this.isPlaying = true;
                }else{
                    this.$refs.audioPlayerRef.getAudioPlayer().pause();
                    this.isPlaying = false;
                }
                return;
            }
            let video = null;
            if(this.isVideoFile){
               video = this.$refs.videoPlayerEl.$el.querySelector('video');
            }else{
               video = this.$refs.audioPlayerRefEl;
            }
            if(video.paused){
                video.play();
                this.isPlaying = true;
            }else{
                video.pause();
                this.isPlaying = false;
            }

            try{
                window.blur();
            }catch(e){console.log(e)}
        },

        updatePlayerPauseAction(){
            this.isPlaying = false;
            try{
                if(this.videoFrameCallbackID) {
                    console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                    this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
                }
            }catch(e){console.log(e)}
        },

        updatePlayerPlayAction(){
            this.isPlaying = true;
        },

        ...mapActions("assets",["getCategoryTreefromId","getAssetInfoFromServer"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapMutations("assets",["activeAssetDetailsPlayer"]),
    },
    emits:["hideAssetDetails"],
    data(){
        return{
            controller:{},
            route:"",
            audioLoaded: false,
            isPlaying: false,
            audioUrl:null,
/*             videoOptions: {
				autoplay: false,
                controls: true,
                nativeTextTracks: true,
                controlBar:{
                    'pictureInPictureToggle': false,
                     playToggle: false,
                },
                
				sources: [],
			}, */

            videoOptions: {
                autoplay: false,
                controls: true,
                nativeTextTracks: true,
                controlBar:{
                        'pictureInPictureToggle': false,
                        'progressControl': true,
                        'remainingTimeDisplay': false,

                    volumePanel: {
                        inline: false,
                        vertical: true
                    },

                    playToggle: false
                },
                preload: "metadata", //loadmetadata such as duration required for range slider, won't load whole video
                sources: []
			},
            svgIconForStorageClass:{"Amazon S3 Glacier":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Amazon S3 Glacier Instant Retrieval":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Amazon S3 Standard":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Disk":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>' },
            isPlayerCanBeLoaded:false,
            currentVideoSpeed : 1,    
            frameRate: 25, 
            audioPlayerFileInfo:null,
            audioSubclipDetails:null,                 
        }
    },
    components:{
        // myVideo
        VideoPlayer,
        customAudioPlayer
    },
    created(){
        window.addEventListener('keydown', this.handleAssetDocKeyBoardShortcuts);
        if ((this.basicAssetInfo.category_id)&&(!("path" in this.basicAssetInfo))){
            this.updateRoute(this.basicAssetInfo.category_id)
        }

        this.frameRate = this.basicAssetInfo.frame_rate;

        this.registerForNotification()

        if(this.basicAssetInfo && this.basicAssetInfo.asset_type && this.basicAssetInfo.asset_type == 'subclip'  && (!this.basicAssetInfo.subclip_type || ["soft","smart","image_captioned"].includes(this.basicAssetInfo.subclip_type))){
                this.getMasterAssetForSubclip(this.basicAssetInfo).then((data) => {
                  if(this.isVideoFile){
                    this.videoOptions.sources = [{
                        src:this.getLowresPath(data),
                        type: "video/mp4"
                    }];
                    this.isPlayerCanBeLoaded = true;
                   }
                   if(this.isAudioFile){
                        this.audioPlayerFileInfo = data;
                        this.subclipDetails = {"markers":this.basicAssetInfo.markers};
                        this.audioUrl = this.getAudiowaveform(data)
                    }
                });
                return;
        }

        this.isPlayerCanBeLoaded = true;

        if (this.basicAssetInfo.mime_type.startsWith("video")){
            this.videoOptions.sources = [{
                src:this.getLowresPath(this.basicAssetInfo),
                type: "video/mp4"
			}]
        }else if (this.basicAssetInfo.mime_type.startsWith("audio")){
            this.audioPlayerFileInfo = this.basicAssetInfo;//this.selectedFile;
            this.audioUrl = this.getAudiowaveform(this.basicAssetInfo)
        }
    },
    beforeDestroy(){
        window.removeEventListener('keydown', this.handleAssetDocKeyBoardShortcuts);
        this.unRegisterForNotification();
          try{
            if(this.videoFrameCallbackID) {
                console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
            }
        }catch(e){console.log(e)}
    }
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:30%;
            text-align: start;
        }
        .value-style{
            color: #c7c7c7;
            width: 70%;
            text-align: start;
            margin-inline-start: 11px;
        }
    }
}

.heightSet{
    height: calc(100% - 335px);
    background: $primary-background;
    cursor: text;
    pointer-events: all;
    user-select: text;
}

.selected-thumbnail-display{
    height: 338px;
    width: 100%;
    display: inline-block;
    border: $border-color;
    img{
        height:100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}

div.selected-thumbnail-display img[src^="data:image/svg+xml;charset=utf-8"]{
    height: 70% !important;
    position: relative;
    top: 16px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

video{
    height:100% !important;
    width:100% !important;
    outline: unset !important;
}

::v-deep{
    .vjs_video_3-dimensions, .video-js{
        height:300px !important;
        width:100% !important;
    }
    .video-js{
        height:300px !important;
        width:100% !important;
    }

 .sub-clip-markin-markout-play .video-js .vjs-play-progress {
      background-color: #28cfd8;
  }
  .sub-clip-markin-markout-play .video-js .vjs-play-progress:before {
      font-size: 1.8em!important;
      z-index: 99!important;
      top: -0.43333333333em;
      color: #28cfd8;
  }
  .vjs-sub-clip-marker
  {
    position: absolute;
    background: #ea4863;
    width: 3px;
    height: 18px;
    top: -7px;
    z-index: 30;
    margin-inline-start: -3px;
    border-radius: 3px;
    font-size: 14px;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .sub-clip-markin-markout-play .vjs-control-bar{
    display: flex !important;
    opacity:1 !important;
  }

  .vjs-control-bar{
      display: flex !important;
      opacity:1 !important;
  }

  .player-current-time-division{
      width: auto !important;
  }
} 

.audio-player{
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 26px;
    inset-inline-start:0px;
}

#main_window_palyer_icons_wrapper{
    align-items: center;
    display: flex;
    //height: 100%;
    margin-inline-start: 4px;
    width: 91%;
    justify-content: space-between;
    ul{
      display: inline-flex;
      margin-bottom: 0px !important;
      margin-inline-start: 2px;
      height: 100%;
      li{
        display: inline-flex;
        margin-inline-end: 5px;
        padding: 0px !important;
        color: #bcbcbc;;
      }
    }
    button{
        font-size: 13px;
        width: 37px !important; 
        justify-content: center; 
        display: flex; 
        align-items: center; 
        height: 25px;
    }
    .fast-forward-div, .fast-backward-div{
        display: inline-flex;
        border:1px solid #6c757d;
        color: #bcbcbc;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-inline-end: 6px;
        svg{
          margin-top:0px;
          width:20px;
          height:20px;
          margin-inline-end: 5px;
          fill: #6c757d;
        }
    }
    .fast-forward-div:hover, .fast-backward-div:hover{
      background-color: #6c757d;
      border-color: #4a4a4a;
      svg{
        fill: #eee;
      }
    }  

    .active-speed{
      border-color: $active-blue;
      color: $active-blue;
    }

    .active-speed:hover{
      color:#eee !important;
    }  

/*     .reset-btn{
      display: inline-flex;
      border:1px solid #6c757d;
      color: #b7b7b7;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      margin-inline-end: 6px;
    }

    .reset-btn:hover{
      background-color: #6c757d;
      border-color: #4a4a4a;
      color:#eee;
    }   */
}

.storage-type-icon{
    margin-inline-end:4px;
    margin-top:2px;
}
</style>